export default __webpack_public_path__ + "static/media/LineArrow.91519b31.png";